const BASE_URL = {
  feVersion: 'fe-version',
};

export default BASE_URL;
